import React, { Component } from "react";
import ResetPasswordForm from "./components/ResetPasswordForm";
import { connect } from "react-redux";
import { verifyPasswordResetCode, changePassword } from "../../actions/userActions";

class ResetPasswordPage extends Component {
  componentWillMount() {
    this.props.actions.verifyPasswordResetCode();
  }
  render() {
    return (
      <div className="resetpassword page">
        <ResetPasswordForm onSubmit={this.props.actions.changePassword} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: {
    changePassword: ({ password }) => dispatch(changePassword(password)),
    verifyPasswordResetCode: () => dispatch(verifyPasswordResetCode()),
  },
});

export default connect(null, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/scenes/ResetPasswordPage/index.js